// extracted by mini-css-extract-plugin
module.exports = {"CoursesList":"CoursesListBlock_CoursesList__20eQt","AdditionalMessage":"CoursesListBlock_AdditionalMessage__1cxJo"};